<template>
    <div :style="{'height': 'calc(100vh - 50px)','background-color':'#F7F7F7'}" id="outermost">
      <van-nav-bar title="个人中心" id="topbar"/>
      <div class="topBg">
        <div class="headImgDiv">
          <img v-if="avartarId" class="headImg" :src="apiUrl + 'download/' + avartarId" @click="showAvatar(avartarId)"/>
          <img v-else class="headImg" src="../../assets/headPortrait.png">
        </div>
      </div>
      <div class="infoDiv" @click="toUserInfo">
        <van-row type="flex" justify="space-between" align="center">
          <van-col style="display:flex;align-items:center;">
            <div class="infoText">
              <div>用户资料</div>
            </div>
          </van-col>
          <van-col>
            <img class="rightIcon" src="../../assets/right.png">
          </van-col>
        </van-row>
      </div>
      <div class="infoDiv" @click="createshow = true">
        <van-row type="flex" justify="space-between" align="center">
          <van-col style="display:flex;align-items:center;">
            <div class="infoText">
              <div>修改密码</div>
            </div>
          </van-col>
          <van-col>
            <img class="rightIcon" src="../../assets/right.png">
          </van-col>
        </van-row>
      </div>
      <div class="infoDiv2" @click="toLogout">
        <div>退出登录</div>
      </div>

      <van-action-sheet v-model="createshow" title="密码修改">
        <div class="content">
            <van-form @submit="onCreateSubmit">
                <van-field
                    v-model="oldpasswd"
                    name="旧密码"
                    label="旧密码"
                    type="password"
                    placeholder="请输入旧密码"
                    :rules="[{ required: true, message: '此项必填' }]"
                />
                <van-field
                    v-model="newpasswd"
                    name="新密码"
                    label="新密码"
                    type="password"
                    placeholder="请输入新密码"
                    :rules="[{ required: true, message: '此项必填' }]"
                />
                <van-field
                    v-model="newpasswd2"
                    name="新密码"
                    label="新密码"
                    type="password"
                    placeholder="请输入新密码"
                    :rules="[{ required: true, message: '此项必填' }]"
                />
                <div style="margin: 32px 16px 16px 16px;">
                    <van-button round block type="info" native-type="submit">
                    保存
                    </van-button>
                </div>
                </van-form>
        </div>
    </van-action-sheet>

      <!--   底部定义组件   -->
      <tabular :active="3"/>

    </div>
</template>
<script>
    import $ from '@/fly'
    import { Toast, Dialog, ImagePreview } from 'vant';
    import Setting from '@/setting';
    import Tabular from '@/components/tabbar.vue';
    export default {
      name: 'common-me',
      components: { Tabular },
      data () {
        return {
          clientHeight: window.screen.height,
          createshow: false,
          newpasswd: '',
          newpasswd2: '',
          oldpasswd: '',
          apiUrl: Setting.apiBaseURL,
          avartarId: ''
        }
      },
      computed: {},
      methods: {
        // 头像
        showAvatar (id) {
          ImagePreview({
            images: [
              Setting.apiBaseURL + 'download/' + id
            ],
            closeable: true
          });
        },
        // 修改密码
        onCreateSubmit () {
          if (this.oldpasswd && this.newpasswd && this.newpasswd2) {
            if (this.newpasswd !== this.newpasswd2) {
              Toast('二次密码输入不一致')
            } else {
              var that = this;
              $.put('user/password', {
                originalPassword: this.oldpasswd,
                username: this.$store.state.admin.user.info.username,
                newPassword: this.newpasswd
              }).then(res => {
                if (res === 0) {
                  Toast.fail('修改失败，当前密码输入错误');
                } else {
                  Toast.success('修改成功,请重新登录');
                  that.createshow = false;
                  setTimeout(function () {
                    that.logout();
                  }, 1500);
                }
                that.oldpasswd = ''
                that.newpasswd = ''
                that.newpasswd2 = ''
              });
            }
          } else {
            Toast('请填写完整信息')
          }
        },
        //用户资料
        toUserInfo () {
          this.$router.push({ name: 'common-userInfo' });
        },
        // 退出登录
        logout () {
          localStorage.removeItem('token');
          localStorage.removeItem('uuid');
          localStorage.removeItem('user');
          this.$router.push('/login');
        },
        // 退出提示
        toLogout () {
          Dialog.confirm({
            title: '是否退出登录'
          }).then(() => {
            this.logout();
          })
        }
      },
      mounted () {
        this.avartarId = JSON.parse(localStorage.getItem('user')).avatar;
      }
    }

</script>

<style lang="less" scoped>
  .topBg{
    height: calc(98vh - 50px);
    height:500px;
    margin-top: -5px;
    width: 100%;
    background: url(../../assets/meBg.png) no-repeat;
    background-size: 100%;
  }
  .headImgDiv{
    line-height: 400px;
    text-align: center;
  }
  .headImg{
      width: 240px;
      height: 240px;
      border-radius: 50%;
      border:15px solid #3359fa;
  }
  .infoDiv{
    background-color: #FFFFFF;
    width: 100%;
    padding: 30px;
    margin-bottom: 25px;
    border-radius: 5px;
  }
  .rightIcon{
    width: 25px;
  }
  .infoDiv2{
    background-color: #FFFFFF;
    width: 100%;
    padding: 38px;
    margin-bottom: 25px;
    border-radius: 5px;
    text-align: center;
    color: #F65B5B;
    font-weight: bold;
    font-size: 28px;
  }
</style>
